import logo from "./gif-files/logo-small.gif";
import mainlogo from "./gif-files/logo-main.gif";

export const GifPath = {
    logo,
    mainlogo,
};